import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/public/images/third-party-blog-placeholder.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default","TabsContent"] */ "/var/www/ouinex.com/frontend/src/app/[locale]/blog/_components/NavigationTabs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/blocks/Pagination.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/components/NavigationLink.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/components/ResponsiveImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/var/www/ouinex.com/frontend/src/components/ui/separator.jsx");
